export default __webpack_public_path__ + "static/media/premium.83f31dda.svg";